import { useMutation, useQueryClient } from "@tanstack/react-query";
import galleriesMediaAPI from "../../api/galleries-media/api";

export function useUpdateGalleryMedia() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: galleriesMediaAPI.updateGalleryMedia,
    onSuccess: (data, variables) => {
      // Invalidate and refetch galleries media list
      queryClient.invalidateQueries({ queryKey: ["galleries-media"] });
    },
    onError: (error) => {
      console.error("Update gallery media failed:", error);
    },
  });
}
